module.exports = __webpack_public_path__ + "img/emptybox.a54b9590.png";